import {CheckCircleFilled, CheckCircleTwoTone, CheckOutlined} from '@ant-design/icons'
import {Upload} from 'antd'
import React from 'react'
import './ImageSelect.less'
import {theme} from 'antd'

export type ImageSelectProps = {
  urls: string[]
  selectedUrl?: string
  onUrlSelected?: (url: string) => void
}

export function ImageSelect({urls, selectedUrl, onUrlSelected = () => {}}: ImageSelectProps) {
  const {
    token: {colorPrimary},
  } = theme.useToken()

  return (
    <div
      style={{
        color: colorPrimary,
      }}
    >
      <Upload
        className="image-select"
        listType="picture-card"
        fileList={urls.map((url) => ({
          uid: url,
          name: url,
          thumbUrl: url,
          status: url === selectedUrl ? 'success' : undefined,
        }))}
        showUploadList={{
          showRemoveIcon: false,
          previewIcon: <CheckOutlined style={{color: 'white', fontSize: 22}} />,
        }}
        onPreview={(file) => onUrlSelected(file.name)}
      />
    </div>
  )
}
